import { Grid } from "@mui/material";
import { FastField } from "formik";
import {
  MySelect,
  MyTextField
} from "../../Lib/componentLibrarys";
import { useState } from "react";
import Api from "../../../api2";

export const FormNhap = ({ values, errors, setFieldValue, linhVucList }) => {
  const [appList, setAppList] = useState([]);

  const getApiListApp = (idlinhvuc, page, size) => {
    new Api()
      .GetAppByIdLinhVuc({ idlinhvuc: idlinhvuc, page: page || 1, size: size || 100 })
      .then(data => {
        if (data.code === 200) {
          setAppList(data?.data?.result?.data);
        }
      })
      .catch(err => {})
      .finally(() => {});
  };
  return (
    <div>
      <Grid container spacing={1} style={{ marginTop: "0px" }}>
        <Grid item xs={6}>
          <MySelect
            required
            label="Lĩnh vực:"
            placeholder="Chọn..."
            value={values?.linhVuc}
            options={linhVucList || []}
            name="ten"
            onChange={(event, value) => {
              setFieldValue(`linhVuc`, value);
            }}
            errors={errors?.linhVuc}
            helperText={errors?.linhVuc}
          />
        </Grid>
        <Grid item xs={6}>
          <MySelect
            required
            label="Ứng dụng:"
            placeholder="Chọn..."
            value={values?.app}
            options={appList || []}
            name="name"
            onChange={(event, value) => {
              setFieldValue(`app`, value);
            }}
            errors={errors?.app}
            helperText={errors?.app}
            onOpen={() => {
              values?.linhVuc?.id &&
              getApiListApp(values.linhVuc.id, 1, 100);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <FastField name="moduleCode">
            {({ field }) => (
              <MyTextField
                required
                label="Mã nhóm chức năng:"
                placeholder="Nhập..."
                errors={errors?.moduleCode}
                helperText={errors?.moduleCode}
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FastField name="name">
            {({ field }) => (
              <MyTextField
                required
                label="Tên nhóm chức năng:"
                placeholder="Nhập..."
                errors={errors?.name}
                helperText={errors?.name}
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={12}>
          <FastField name="description">
            {({ field }) => (
              <MyTextField
                label="Mô tả:"
                placeholder="Nhập..."
                {...field}
              />
            )}
          </FastField>
        </Grid>
      </Grid>
    </div>
  );
};

export const FormNhapUpdate = ({ values, errors, setFieldValue }) => {
  return (
    <div>
      <Grid container spacing={1} style={{ marginTop: "0px" }}>
        <Grid item xs={6}>
          <FastField name="moduleCode">
            {({ field }) => (
              <MyTextField
                required
                label="Mã nhóm chức năng:"
                placeholder="Nhập..."
                errors={errors?.moduleCode}
                helperText={errors?.moduleCode}
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FastField name="name">
            {({ field }) => (
              <MyTextField
                required
                label="Tên nhóm chức năng:"
                placeholder="Nhập..."
                errors={errors?.name}
                helperText={errors?.name}
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={12}>
          <FastField name="description">
            {({ field }) => (
              <MyTextField
                label="Mô tả:"
                placeholder="Nhập..."
                {...field}
              />
            )}
          </FastField>
        </Grid>
      </Grid>
    </div>
  );
};